module.exports = __webpack_public_path__ + "static/media/terminos.6808e398.pdf";